export default function (item) {
  let ingredientsValue = 0
  for (const key in item.additional_ingredients) {
    const obj = item.additional_ingredients[key]
    ingredientsValue += obj.ingredient.price * obj.quantity
  }

  return ingredientsValue + item.variant.price
}
